import styled from "styled-components";
import GoBack from "../../icons/GoBack";
import { GlobalStyle, GlobalDarkStyle } from "../../constants/global-style";
import { ChargeType } from "../../constants";
import { useClientTopUpStore } from "../../store";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
const Header: React.FC = () => {
  const { activeBar, setActiveBar } = useClientTopUpStore();
  const navigate = useNavigate();
  const location = useLocation();
  const routeTheme = new URLSearchParams(location.search).get("theme");
  const globalStyle = routeTheme === "dark" ? GlobalDarkStyle : GlobalStyle;
  const onBarClick = (barType: ChargeType) => {
    setActiveBar(barType);
    if (routeTheme) {
      navigate(`/clientTopUp?activeName=${barType}&theme=${routeTheme}`);
    } else {
      navigate(`/clientTopUp?activeName=${barType}`);
    }
  };
  const returnToWorkbench = () => {
    if ((window as any).channelObject?.invokeMethod) {
      (window as any).channelObject.invokeMethod("returnToWorkbench", true);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const activeNameValue = params.get("activeName");
    if (activeNameValue) {
      setActiveBar(
        activeNameValue === ChargeType.Membership
          ? ChargeType.Membership
          : ChargeType.Recharge
      );
    } else {
      !activeBar && setActiveBar(ChargeType.Membership);
    }
  }, [location.search, activeBar, setActiveBar]);
  return (
    <HeaderWrapper>
      <GoBackWrapper onClick={() => returnToWorkbench()}>
        <GoBack />
        返回工作台
      </GoBackWrapper>
      <TouchBarWrapper>
        <TouchBarContent
          className={globalStyle[activeBar].headerActiveClassName}
        >
          <div
            className="left-bar"
            onClick={() => onBarClick(ChargeType.Recharge)}
          >
            充值中心
          </div>
          <div
            className="right-bar"
            onClick={() => onBarClick(ChargeType.Membership)}
          >
            我的会员
          </div>
        </TouchBarContent>
      </TouchBarWrapper>
    </HeaderWrapper>
  );
};
const HeaderWrapper = styled.div`
  padding: 14px 18px;
  display: flex;
  align-items: center;
  position: relative;
`;
const GoBackWrapper = styled.div`
  color: #fff;
  font-size: 12px;
  line-height: 22px;
  position: absolute;
  cursor: pointer;
  pointer-events: auto;
`;
const TouchBarWrapper = styled.div`
  position: relative;
  width: 184px;
  height: 34px;
  margin: 0 auto;
  pointer-events: auto;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 31px;
`;
const TouchBarContent = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  padding: 3px;
  box-sizing: border-box;
  cursor: pointer;
  .left-bar {
    width: 50%;
    text-align: center;
    line-height: 26px;
  }
  .right-bar {
    width: 50%;
    text-align: center;
    line-height: 26px;
  }
  &.left-active-style {
    .left-bar {
      color: rgba(255, 255, 255, 0.6);
    }
    .right-bar {
      color: #1da0ff;
      background: linear-gradient(
          261.27deg,
          rgba(193, 255, 248, 0.64) -7.65%,
          rgba(255, 255, 255, 0) 36.38%
        ),
        linear-gradient(0deg, #ffffff, #ffffff);
      border-radius: 26px;
      backdrop-filter: blur(95px);
      border: 0.5px solid;
      border-image-source: linear-gradient(
        260deg,
        #ffffff -0.68%,
        rgba(255, 255, 255, 0) 33.05%
      );
    }
  }
  &.right-active-style {
    .right-bar {
      color: rgba(255, 255, 255, 0.6);
    }
    .left-bar {
      color: #1da0ff;
      background: linear-gradient(
          261.27deg,
          rgba(193, 255, 248, 0.64) -7.65%,
          rgba(255, 255, 255, 0) 36.38%
        ),
        linear-gradient(0deg, #ffffff, #ffffff);
      border-radius: 26px;
      backdrop-filter: blur(95px);
      border: 0.5px solid;
      border-image-source: linear-gradient(
        260deg,
        #ffffff -0.68%,
        rgba(255, 255, 255, 0) 33.05%
      );
    }
  }
`;

export default Header;
